import { Box, useToast } from '@chakra-ui/react';
import * as Sentry from '@sentry/react';
import React from 'react';
import { useNavigate } from 'react-router-dom';

import { typeguards as commonTypeguards } from '@finley-technologies/common';

import 'source/borrower/borrower.scss';
import { FundingRequestsViewTemplate } from 'borrower/domains/fundingRequests/ui/ViewTemplate';
import {
  errorToastConfig,
  errorToastId,
} from 'packages/common-frontend/constants';
import { FundingRequestHistoryViewContainer } from 'packages/funding-requests/ui/history/ViewContainer';
import { statusConfigs } from 'packages/funding-requests/ui/shared/StatusBadge';

export const FundingRequestsHistoryRoute = () => {
  const allowedStatuses = commonTypeguards.getKeys(statusConfigs);
  const toast = useToast();
  const navigate = useNavigate();

  let routeLevelError = false;
  return (
    <Box className="main">
      <Sentry.ErrorBoundary
        onError={() => {
          if (!routeLevelError && !toast.isActive(errorToastId)) {
            errorToastConfig.title = `Failed to load draw requests page`;
            routeLevelError = true;
            toast(errorToastConfig);
            navigate('/funding-requests');
          }
        }}
      >
        <FundingRequestsViewTemplate
          fundingRequestId=""
          selectedTab="history"
          isCreditFacilitySelectDisabled={false}
        >
          <FundingRequestHistoryViewContainer
            allowedStatuses={allowedStatuses}
          />
        </FundingRequestsViewTemplate>
      </Sentry.ErrorBoundary>
    </Box>
  );
};
